import Modal from "../UI/Modal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/users/users.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";

const UserViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedUser,
    selectedUserLoading,
    selectedUserError,
  } = useSelector((state) => state.users);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle del usuario"
      size="lg"
    >
      {selectedUserLoading && (
        <Loader
          center
          text="Cargando información del usuario..."
          delay={150}
          type="dots"
        />
      )}

      {selectedUserError && <p className="text-danger">{selectedUserError}</p>}

      {!selectedUserLoading && selectedUser && (
        <div className="row g-4">
          {/* Columna Izquierda */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:account-outline"
                label="Nombre"
                value={selectedUser.nombre_completo}
              />
              <Field
                icon="mdi:email-outline"
                label="Email"
                value={selectedUser.email}
              />
              <Field
                icon="mdi:phone-outline"
                label="Teléfono"
                value={selectedUser.telefono}
              />
              <Field
                icon="mdi:card-account-details-outline"
                label="CURP"
                value={selectedUser.curp}
              />
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:school-outline"
                label="Escuela"
                value={selectedUser.escuela_nombre}
              />
              <Field
                icon="mdi:office-building-outline"
                label="Plantel"
                value={selectedUser.plantel_nombre}
              />
              <Field
                icon="mdi:account-badge-outline"
                label="Rol"
                value={selectedUser.rol}
              />
              <Field
                icon="mdi:calendar-outline"
                label="Nacimiento"
                value={selectedUser.fecha_nacimiento}
              />
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default UserViewModal;
